import {css} from 'lit';
export const styles = css`:host {
  --avatar-size: 100px;
  --link-text-active: var(--body-text);

  display: block;
  text-align: center;
  width: var(--avatar-size);
  line-height: var(--line-height-nav);
}

a {
  display: block;
  position: relative;
  color: var(--body-text);
}

a > ef-badge {
  position: absolute;
  top: -8px;
  right: -4px;
}

a > ef-icon {
  position: absolute;
  z-index: 1;
  top: 8px;
  left: 8px;
  color: var(--contrast-light);
  border-top-left-radius: 4px;
}

ef-avatar {
  overflow: hidden;
  margin-bottom: 4px;
}

.placeholder {
  width: var(--avatar-size);
  height: var(--avatar-size);
  display: flex;
  justify-content: center;
  align-items: center;
  margin-bottom: 4px;
  font-size: 32px;
  color: var(--dark-text-secondary);
}

.favorite ef-avatar::before {
  content: '';
  display: block;
  position: absolute;
  top: -50%;
  left: -60%;
  width: 100%;
  height: 100%;
  z-index: 1;
  background: rgba(var(--contrast-dark-rgb), 0.4);
  transform: rotate(40deg);
}

slot {
  font-size: var(--font-size-sm);
  font-weight: 700;
}
`;
export default styles;
